export { CAchievementTemplate } from "./Achievement.tsx";
export { CDescriptiveTemplate } from "./Descriptive.tsx";
export { CSatisfactionTemplate } from "./Satisfaction.tsx";
